import {
  Building_Sanction_Circular_2010_11_List,
  BuildingCircularSiteMenuList,
} from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Building_Sanction_Circular_2010_11 = () => (
  <TableStructure
    list={Building_Sanction_Circular_2010_11_List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2010-11"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2010_11;
